import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";

export default function BannerFormModal({
  open,
  mode,
  form,
  setField,
  onClose,
  onSubmit,
  imageErrors,
  handleLargeImageChange,
  handleSmallImageChange,
}) {
  const isEdit = mode === "edit";
  let disableSubmit = false;
  const isValidOrder = /^[1-9]\d*$/.test(String(form.ord));

  if (mode === "add") {
    disableSubmit =
      !!imageErrors.largeImageFile ||
      !!imageErrors.smallImageFile ||
      !form.largeImageFile ||
      !form.smallImageFile ||
      !isValidOrder;
  }

  if (mode === "edit") {
    disableSubmit = !isValidOrder;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEdit ? "Edit Banner" : "Add Banner"}</DialogTitle>

      <DialogContent>
        <TextField
          label="Title"
          fullWidth
          margin="normal"
          value={form.title}
          onChange={(e) => setField("title", e.target.value)}
        />

        <TextField
          label="Description"
          fullWidth
          margin="normal"
          value={form.description}
          onChange={(e) => setField("description", e.target.value)}
        />

        <FormControl fullWidth margin="normal">
          <InputLabel>Target Screen</InputLabel>
          <Select
            value={form.targetScreen}
            onChange={(e) => setField("targetScreen", e.target.value)}
          >
            <MenuItem value="home">Home</MenuItem>
            <MenuItem value="webinar">Webinar</MenuItem>
            <MenuItem value="training">Training</MenuItem>
          </Select>
        </FormControl>

        <TextField
          label="Order"
          fullWidth
          margin="normal"
          type="text"
          value={form.ord}
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
          onKeyDown={(e) => {
            if (["-", "+", ".", "e", "E"].includes(e.key)) {
              e.preventDefault();
            }
          }}
          onChange={(e) => {
            const value = e.target.value;

            if (value === "") {
              setField("ord", "");
              return;
            }

            if (/^[1-9]\d*$/.test(value)) {
              setField("ord", value);
            }
          }}
        />

        <TextField
          label="Button Text"
          fullWidth
          margin="normal"
          value={form.buttonText}
          onChange={(e) => setField("buttonText", e.target.value)}
        />

        <TextField
          label="Button Link"
          fullWidth
          margin="normal"
          value={form.buttonLink}
          onChange={(e) => setField("buttonLink", e.target.value)}
        />
        <TextField
          label="Expiry Date"
          fullWidth
          margin="normal"
          type="date"
          InputLabelProps={{
            shrink: true,
          }}
          value={form.expireAt || ""}
          onChange={(e) => setField("expireAt", e.target.value)}
        />

        <br />

        <ImageUploadField
          label="Desktop Banner Image"
          disabled={isEdit}
          onChange={handleLargeImageChange}
        />
        {imageErrors.largeImageFile && (
          <div
            style={{
              color: "red",
              fontSize: "12px",
              marginTop: "4px",
            }}
          >
            {imageErrors.largeImageFile}
          </div>
        )}

        <ImageUploadField
          label="Mobile Banner Image"
          disabled={isEdit}
          onChange={handleSmallImageChange}
        />
        {imageErrors.smallImageFile && (
          <div
            style={{
              color: "red",
              fontSize: "12px",
              marginTop: "4px",
            }}
          >
            {imageErrors.smallImageFile}
          </div>
        )}

        {/* TODO */}
        {/* <ImageUploadField
          label="Banner Icon"
          disabled={isEdit}
          onChange={(file) => setField("bannerIcon", file)}
        /> */}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          color="primary"
          variant="contained"
          onClick={onSubmit}
          disabled={disableSubmit}
        >
          {isEdit ? "Update" : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function ImageUploadField({ label, disabled, onChange }) {
  return (
    <div style={{ marginBottom: "16px" }}>
      <label
        style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}
      >
        {label}
      </label>
      <input
        type="file"
        disabled={disabled}
        onChange={(e) => onChange(e.target.files[0])}
      />
    </div>
  );
}
